import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ComponentsModule } from '@components/components.module';
import { DialogsModule } from '@routes/dialogs/dialogs.module';
import { TicketsRoutingModule } from '@routes/tickets/tickets-routing.module';
import { TicketEditComponent } from '@routes/tickets/ticket-edit/ticket-edit.component';
import { CustomerComponent } from '@routes/tickets/ticket-edit/contents/customer/customer.component';
import { ProductComponent } from '@routes/tickets/ticket-edit/contents/product/product.component';
import { ConversationComponent } from './details/conversation/conversation.component';
import { ScheduleComponent } from './contents/schedule/schedule.component';
import { BasicComponent } from './contents/basic/basic.component';
import { ContentsTemplateComponent } from './contents/contents-template.component';
import { PricingComponent } from './contents/pricing/pricing.component';
import { SymptomsComponent } from '@routes/tickets/ticket-edit/contents/symptoms/symptoms.component';
import { DetailInfoComponent } from './details/detail-info/detail-info.component';
import {
  ConversationEditComponent
} from '@routes/tickets/ticket-edit/details/conversation/conversation-edit/conversation-edit.component';

@NgModule({
  declarations: [
    TicketEditComponent,
    CustomerComponent,
    ProductComponent,
    ConversationComponent,
    ConversationEditComponent,
    SymptomsComponent,
    ScheduleComponent,
    BasicComponent,
    ContentsTemplateComponent,
    PricingComponent,
    DetailInfoComponent,

  ],
  imports: [
    CommonModule,
    SharedModule,
    ComponentsModule,
    DialogsModule,
    TicketsRoutingModule,
  ],
  exports: []
})

export class TicketEditModule {
}
